import React from 'react';
import styled from 'styled-components';
import { defaultFont } from '../../../theme/typography';
import { black400, curiousBlue300, white } from '../../../theme/colors';
import { Button } from '../../../components/Button';
import { TitleStyle } from '../dashboardLayoutStyle';
import { Tooltip } from '@material-ui/core';
import themeSizes from '../../../theme/themeSizes';

export const FormBlockStyle = styled.section`
  margin: ${props => props.margin !== undefined ? props.margin : '0'};

  section {
    max-width: 100%;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(91, 127, 220, 0.05), 0 2px 4px -1px rgba(91, 127, 220, 0.025);
    min-height: 185px;
    padding: 32px;
    
    @media (max-width: 995px) {
        padding: 20px;
    }

    @media (max-width: 768px) {
        padding: 16px 12px;
    }
  }
`;

const HeadingStyle = styled(TitleStyle)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  color: #0f172a;
  font-weight: 600;

  & > p {
    align-content: center;
    margin: 0;
  }

  @media ${themeSizes.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    & > p {
      width: 100%;
    }
  }
`;

const ActionButtonsStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 995px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
    margin-top: 24px;
  }
`;

export const FormContainer = ({
  title = '',
  children,
  footerLocation = '46%',
  actionButtons = true,
  margin,
  padding,
  titleCornerElement,
  rightSideTitleElement,
  onClickAction = () => {
  },
  onCancelAction = () => {
  },
  subElement,
  isClickDisabled = false,
  skuTemplateName,
  isLoading = false,
  actionButtonText = 'save'
}) => {
  return (
    <FormBlockStyle margin={margin} padding={padding}>
      {title || rightSideTitleElement ? (
        <HeadingStyle>
          <p>{title}</p>
          <p>{rightSideTitleElement}</p>
        </HeadingStyle>
      ) : null}
      {subElement}
      <section>
        {children}
        {actionButtons ? (
          <ActionButtonsStyle className="form-action-buttons">
            {onCancelAction && (
              <Button
                width="92px"
                borderRadius="8px"
                fontStyle={defaultFont}
                changeOnlyBgColor
                color={curiousBlue300}
                bgColor={white}
                onClick={onCancelAction}
                className="cancel-button"
              >
                Cancel
              </Button>
            )}

            <Tooltip
              title={
                !!skuTemplateName ? "Invoice details name already assigned" : ""
              }
            >
              <span className="save-button-wrapper">
                <Button
                  width="92px"
                  borderRadius="8px"
                  fontStyle={defaultFont}
                  onClick={(e) => {
                    if (!isClickDisabled) {
                      onClickAction(e);
                    }
                  }}
                  isDisabled={!!skuTemplateName || isClickDisabled}
                  isLoading={isLoading}
                  className="save-button"
                >
                  {actionButtonText}
                </Button>
              </span>
            </Tooltip>
          </ActionButtonsStyle>
        ) : null}
      </section>
    </FormBlockStyle>
  );
}